module.exports = __webpack_public_path__ + "img/service-part3-en.330fabc1.png";